/**
 * assets/handoffs/design_handoff_account_settings — Profile tab restyle
 * onto Untitled UI. Structure/actions unchanged from the legacy page; see
 * SettingsPage/ for the three card components.
 */
import React, { useEffect } from "react";
import { useHistory } from "react-router-dom";
import { useUserStore } from "./../../../hooks/redux/user";
import { useAppStore } from "./../../../hooks/redux/app";
import TabbedSettingsPage from "../templates/TabbedSettingsPage/TabbedSettingsPage";
import { ACCOUNT_SETTINGS_TABS } from "../templates/TabbedSettingsPage/settingsTabs";
import BasicInformationCard from "./SettingsPage/BasicInformationCard";
import PasswordCard from "./SettingsPage/PasswordCard";
import DeleteAccountCard from "./SettingsPage/DeleteAccountCard";
import styles from "./SettingsPage/SettingsPage.module.scss";

const SettingsPage = () => {
  const { user, editUser, deleteAccount, remindPassword, logout } =
    useUserStore();
  const { clearErrors } = useAppStore();
  const userModel = user.model || {};

  const history = useHistory();

  useEffect(() => {
    return clearErrors;
  }, []);

  useEffect(() => {
    if (user.deleteAccountSuccess) {
      logout();
      history.push("/login");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user.deleteAccountSuccess, logout]);

  return (
    <TabbedSettingsPage
      title="Account settings"
      subtitle="Applies to you in every workspace you belong to."
      tabs={ACCOUNT_SETTINGS_TABS}
    >
      <div className={styles.page}>
        <BasicInformationCard
          userModel={userModel}
          user={user}
          editUser={editUser}
        />
        <PasswordCard
          email={userModel.email}
          user={user}
          remindPassword={remindPassword}
        />
        <DeleteAccountCard
          email={userModel.email}
          user={user}
          deleteAccount={deleteAccount}
        />
      </div>
    </TabbedSettingsPage>
  );
};

export default SettingsPage;
